export function formatHot(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function formatDate(date: string): string {
  return date.replace(/-/g, ".");
}